import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {
    AppAlertService, AuthenticationService,
    FormsService,
    SettingsAccountService,
    SubtitlesService, UserService
} from "../../../core";
import {
    FormEmailInputComponent
} from "../../../common/forms/form-email-input/form-email-input.component";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'delete-account-form',
  standalone: true,
    imports: [
        FormActionButtonsComponent,
        FormButtonComponent,
        ReactiveFormsModule,
        FormEmailInputComponent
    ],
  templateUrl: './delete-account-form.component.html',
  styleUrl: './delete-account-form.component.scss'
})
export class DeleteAccountFormComponent implements OnInit {
    @Output() close = new EventEmitter();
    emailForm: FormGroup;

    constructor(
        private appAlert: AppAlertService,
        private authentication: AuthenticationService,
        private fb: FormBuilder,
        private forms: FormsService,
        private http: HttpClient,
        private settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
        private user: UserService,
    ) {
    }

    ngOnInit(): void {
        this.emailForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
        this.emailForm.patchValue({email: this.settingsAccount.accountInformation.accountEmail});
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    closeForm(): void {
        this.close.emit();
    }

    get emailControl() {
        return this.emailForm.get('email') as FormControl;
    }

    closeAlert() {
        if (this.user.user_id) {
            this.authentication.logout();
        } else {
            window.location.href = '/login';
        }
    }

    deleteAccount() {
        const isEmailValid = this.forms.validateEmail(this.emailForm.value.email);
        if (!isEmailValid) {
            this.appAlert.openAlertDialog({
                title: this.subtitles.setSubtitle(3806),
                message: this.subtitles.setSubtitle(1342),
                okButtonText: this.subtitles.setSubtitle(475),
            });
            return;
        }
        this.closeForm();

        this.http.delete(`/api/v1/account/email/${this.emailForm.value.email}/i18n/${this.subtitles.language}`)
            .subscribe({
                next: () => {
                    this.appAlert.openAlertDialog({
                        title: this.subtitles.setSubtitle(3806),
                        message: this.subtitles.setSubtitle(13578),
                        okButtonText: this.subtitles.setSubtitle(1129),
                        okFunction: this.closeAlert.bind(this),

                    });
                },
                error: () => {
                    this.appAlert.openAlertDialog({
                        title: this.subtitles.setSubtitle(3806),
                        message: this.subtitles.setSubtitle(1941),
                        okButtonText: this.subtitles.setSubtitle(475),
                        okFunction: this.closeAlert.bind(this),
                    });
                }
            });
    }
}
